// extracted by mini-css-extract-plugin
export default {"active":"LeftNavProjectTab_active__A35vg","inactive":"LeftNavProjectTab_inactive__Mtu7D"};